import {IS_ActionableEnabled} from "back/commons/actionables";
import {BarActions} from "back/commons/widgets/bars";
import {IWedEditor, IWedEditorMain, OWedEditorMainConfig, WedMgr} from "back/edit/wed/wedEditor";
import {ACTION, Action} from "lib/commons/actions";
import {REG} from 'lib/commons/registry';
import {DOM, INodeFilter, JSX} from "lib/commons/xml/dom";
import {DOMSH} from "lib/commons/xml/domsh";
import {IWedletActionCtx} from "back/edit/wed/wedlets/wedlet";
import {isEltBoxSelection} from "back/edit/wed/features/boxSel";


export interface OWedEditorCommonBarConfig extends OWedEditorMainConfig {
	/** Désactive cette commonBar. */
	hideCommonBar?: boolean;

	/** WedCommonBar pré-existante déjà associée à un autre éditeur maitre. */
	commonBar?: WedCommonBar;
}

export interface IWedEditorCommonBar extends IWedEditorMain {
	commonBar?: WedCommonBar;
}

export function AgCommonBarEditor(cls: any): any {
	const proto = cls.prototype as IWedEditorCommonBar;
	const superInit = proto.initialize;
	proto.initialize = function (this: IWedEditorCommonBar, config: OWedEditorCommonBarConfig) {
		superInit.call(this, config);
		if (!config.hideCommonBar) {
			if (config.commonBar) {
				config.commonBar.attachSubEditor(this);
			} else if (this.barLayout) {
				this.commonBar = new WedCommonBar(this, config);
			}
			//A revoir : Actuellement affichage du menu contextuel géré par ContextMenuDeskFeat. A réactiver si ContextMenuDeskFeat.isIn(desk) === false ?
			//this.wedMgr.accelKeyMgr.addAccelKey(" ", 'accel', new Action<IWedEditorCommonBar>('menuBar').setExecute((ctx: IWedEditorCommonBar) => {ctx.commonBar.acquireFocus()}));
		}
		return this;
	};
	return cls;
}

export class WedCommonBar {

	/** toolbar stable, certaines actions peuvent dépendre du focus courant de l'éditeur, de l'état de la house... */
	stableStartBar: BarActions<IWedEditor>;
	stableEndBar: BarActions<IWedEditor>;

	/** toolbar dynamique en fonction du focus de l'éditeur. */
	focusBar: BarActions<IWedletActionCtx>;

	rootBar: HTMLElement;

	/** Données à rafraichir au prochain cycle. */
	protected _nextRefreshStableBar: boolean;
	protected _nextFocusBar: BarActions<IWedletActionCtx>;

	/** gestion des cycles de refresh. */
	_redrawPlanned: number;
	_requestIdleCallback: (deadline: RequestIdleDeadline) => void;

	constructor(public editor: IWedEditorCommonBar, config: OWedEditorCommonBarConfig) {
		this.rootBar = <div id="commonBar" style="display:flex;"/>;
		editor.barLayout.showBar(this.rootBar);
		editor.wedMgr.hookFct('detachDocHolder', () => {
			// En cas d'association à un nouveau docHoler, on suppr la stableBar pour forcer une reconstruction
			// car les btns de la stableBar peuvent être liés à la house (dirty, histo).
			if (this.editor.wedMgr.docHolderAsync) {
				this.rootBar.textContent = null;
				this.stableStartBar = null;
				this.stableEndBar = null;
			}
		}, true);
		editor.wedMgr.listeners
			.on("redrawBeforeFetch", planRefreshFull)
			.on("redrawAtEnd", planRefreshFull)
			.on("readOnlyChangeAfter", planRefreshFull)
			.on("layoutBarChange", planRefreshStableBar)
			.on("getFocus", onFocus)
			.on("selection", onSelChange)
			.on("killEditor", function (this: void, wedMgr: WedMgr) {
				(wedMgr.wedEditor as IWedEditorCommonBar).commonBar.killBar();
			});
		this.rootBar.addEventListener("keydown", onKeydown.bind(editor));
		this._requestIdleCallback = requestIdleCallback.bind(this);
	}

	killBar() {
		if (this._redrawPlanned) window.cancelIdleCallback(this._redrawPlanned);
	}

	/** Si WedCommonBar pré-existante déjà associée à un autre éditeur maitre. */
	attachSubEditor(editor: IWedEditorCommonBar) {
		editor.commonBar = this;
		editor.wedMgr.listeners
			.on("getFocus", onFocus)
			.on("selection", onSelChange);
	}

	/** Planification d'un redessinement des 2 bars. */
	planRefreshFull() {
		this._nextRefreshStableBar = true;
		this._nextFocusBar = null;
		if (!this._redrawPlanned) this._redrawPlanned = window.requestIdleCallback(this._requestIdleCallback);
	}

	planRefreshStableBar() {
		this._nextRefreshStableBar = true;
		if (!this._redrawPlanned) this._redrawPlanned = window.requestIdleCallback(this._requestIdleCallback);
	}

	/** Planification d'un redessinement de la focus bar. */
	planChangeFocusBar(focusBar: BarActions<IWedletActionCtx>) {
		//console.trace("planChangeFocusBar:::", focusBar)
		this._nextFocusBar = focusBar;
		if (!this._redrawPlanned) this._redrawPlanned = window.requestIdleCallback(this._requestIdleCallback);
	}

	/** Execute le redessinement. */
	redraw() {
		if (!this.stableStartBar) {
			//stableBar pas encore dessinée ou effacée quite à un detachDocHolder()
			const reg = this.editor.wedMgr.reg;
			this.stableStartBar = new BarActions<IWedEditor>().initialize({
				actionContext: this.editor,
				actions: reg.getList("actions:wed:commonbar:start") as Action<IWedEditor>[]
			});
			this.stableStartBar.style.flexShrink = "0";
			this.stableStartBar.style.flexGrow = "1";
			this.rootBar.appendChild(this.stableStartBar);
			const endActions = reg.getList("actions:wed:commonbar:end") as Action<IWedEditor>[];
			if (endActions) {
				this.stableEndBar = new BarActions<IWedEditor>().initialize({
					actionContext: this.editor,
					actions: endActions
				});
				this.stableEndBar.style.flexShrink = "0";
				this.rootBar.appendChild(this.stableEndBar);
			}
			this._nextRefreshStableBar = false;
		} else if (this._nextRefreshStableBar) {
			this.stableStartBar.refreshContent();
			if (this.stableEndBar) this.stableEndBar.refreshContent();
			this._nextRefreshStableBar = false;
		}
		if (this.focusBar === this._nextFocusBar) {
			if (this.focusBar) this.focusBar.refreshContent();
		} else {
			if (this.focusBar) {
				this.focusBar.remove();
				this.focusBar = null;
			}
			if (this._nextFocusBar) {
				const focused = this._nextFocusBar.actionContext.focusedElt;
				if (focused && focused.isConnected) { //race cond si l'elt focusé a été déconnecté (appelé en requestIdleCallback)
					this.focusBar = this._nextFocusBar;
					DOM.setStyle(this.focusBar, "flex-grow", "1000");
					DOM.setStyle(this.focusBar, "border-inline-start", this.stableStartBar ? "1px solid var(--border-color)" : null);
					DOM.setStyle(this.focusBar, "border-inline-end", this.stableEndBar ? "1px solid var(--border-color)" : null);
					this.rootBar.insertBefore(this.focusBar, this.stableEndBar);
					//this.focusBar.refresh(); appelé dans connectedCallback()
				}
			}
		}
	}

	restoreFocusTarget: Element;

	acquireFocus() {
		this.restoreFocusTarget = DOMSH.findDeepActiveElement();
		if (this.focusBar) {
			const focusable = DOMSH.findFlatFirstChild(this.focusBar, DOM.IS_focusable);
			if (focusable) {
				focusable.focus();
				return;
			}
		}
		if (this.stableStartBar) {
			const focusable = DOMSH.findFlatFirstChild(this.stableStartBar, DOM.IS_focusable);
			if (focusable) {
				focusable.focus();
				return;
			}
		}
	}

}

/**
 * Les widgets qui veulent afficher une toolbar lorsque le focus est dans leur descendance doivent
 * implémenter cette interface.
 */
export interface IWedFocusBarPointer extends HTMLElement {
	focusBar?: BarActions<IWedletActionCtx>;
}

const isWedFocusBarPointer: INodeFilter<IWedFocusBarPointer> = function (h: any): h is IWedFocusBarPointer {return h.focusBar != null};

function onFocus(this: void, wedMgr: WedMgr, focusElt: Element) {
	(wedMgr.wedEditor as IWedEditorCommonBar).commonBar.planChangeFocusBar((focusElt as IWedFocusBarPointer).focusBar);
}

function onSelChange(wedMgr: WedMgr, sel: Selection | null): undefined | true {
	const editor = wedMgr.wedEditor as IWedEditorCommonBar;
	//console.log("commonBar:onSelChange:::", sel);
	if (sel == null) {
		editor.commonBar.planChangeFocusBar(null);
		return;
	}
	const focus = DOM.findParentOrSelf(sel.focusNode, null, DOM.IS_element);
	if (!focus) return;
	const eltBoxCtn = DOMSH.findFlatParentEltOrSelf(focus, editor.rootNode, isEltBoxSelection);
	if (eltBoxCtn?.selMode === "caret") {
		//on est bien dans un widget avec sel au caret, sinon on va activer la barre du parent du box sélectionné!
		const focusBarPointer = DOMSH.findFlatParentEltOrSelf(focus, editor.rootNode, isWedFocusBarPointer);
		editor.commonBar.planChangeFocusBar(focusBarPointer ? focusBarPointer.focusBar : null);
	}
}

function onKeydown(this: IWedEditorCommonBar, ev: KeyboardEvent) {
	switch (ev.key) {
	case ' ':
		if (!ACTION.isAccelPressed(ev)) break;
	case 'Escape':
		//Retour du focus à l'éditeur
		ev.stopImmediatePropagation();
		if (this.commonBar.restoreFocusTarget instanceof HTMLElement) this.commonBar.restoreFocusTarget.focus();
		break;
	case 'ArrowLeft':
		// focusBar -> stableBar
		//FIXME RTL ?
		if (this.commonBar.focusBar && this.commonBar.stableStartBar && DOM.isAncestor(this.commonBar.focusBar, ev.target as Node)) {
			const next = DOM.findLastChild(this.commonBar.stableStartBar, IS_ActionableEnabled);
			if (next) {
				ev.stopImmediatePropagation();
				next.focus();
			}
		}
		break;
	case 'ArrowRight':
		// stableBar -> focusBar
		//FIXME RTL ?
		if (this.commonBar.focusBar && this.commonBar.stableStartBar && DOM.isAncestor(this.commonBar.stableStartBar, ev.target as Node)) {
			const next = DOM.findFirstChild(this.commonBar.focusBar, IS_ActionableEnabled);
			if (next) {
				ev.stopImmediatePropagation();
				next.focus();
			}
		}
		break;
	}
}

function planRefreshFull(wedMgr: WedMgr) {
	(wedMgr.wedEditor as IWedEditorCommonBar).commonBar.planRefreshFull();
}

function planRefreshStableBar(wedMgr: WedMgr) {
	(wedMgr.wedEditor as IWedEditorCommonBar).commonBar.planRefreshStableBar();
}


function requestIdleCallback(this: WedCommonBar, deadline: RequestIdleDeadline) {
	if (deadline.timeRemaining() < 5) {
		this._redrawPlanned = window.requestIdleCallback(this._requestIdleCallback);
		return;
	}
	this._redrawPlanned = null;
	this.redraw();
}

REG.reg.addSvcToList("actions:wed:commonbar:start", "undo", 1, "wedEditorUndoAction", 50);
REG.reg.addSvcToList("actions:wed:commonbar:start", "redo", 1, "wedEditorRedoAction", 51);
